import React from "react";
import styled from "styled-components";
import { compose, withHandlers, withState } from "recompose";
import RemoveWatermark from "./RemoveWatermark";
import { PrimaryButton } from "../common/Button";
import customizeImage from "../../../images/customize.png";
import videoImage from "../../../images/video.png";
import PurchaseWatermarkModal from "./PurchaseWatermarkModal";

const StoryActions = ({
  openCustomizeModal,
  openVideoModal,
  width,
  isLoading,
  isCreatingNewStory,
  withWatermark,
  ...props
}) => (
  <Layout width={width}>
    <Row>
      <SmallCtaContainer>
        <Cta
          onClick={openCustomizeModal}
          isLoading={isLoading || isCreatingNewStory}
          disabled={isLoading || isCreatingNewStory}
        >
          <CtaIcon imageSrc={customizeImage} imageAlt="Customize Grid" />
          <CtaLabel>Customize Grid</CtaLabel>
        </Cta>
      </SmallCtaContainer>
      {props.videoFeatureEnabled && (
        <SmallCtaContainer>
          <Cta
            onClick={openVideoModal} 
            isLoading={isLoading} 
            disabled={isLoading}
          >
            <CtaIcon imageSrc={videoImage} imageAlt="Create Video" />
            <CtaLabel>Video Story</CtaLabel>
          </Cta>
        </SmallCtaContainer>
      )}
    </Row>
    <Row>
      <SmallCtaContainer>
        <RemoveWatermark
          isLoading={isLoading || isCreatingNewStory}
          withWatermark={withWatermark}
          withRedBackground={true}
          showPurchaseWatermarkModal={true}
          onClickBuy={props.onClickWithPaymentRequest}
          {...props}
        />
      </SmallCtaContainer>
    </Row>
    <PurchaseWatermarkModal
      withWatermark={withWatermark}
      open={props.openWatermarkModal}
      onClose={props.onCloseModal}
      {...props}
    />
  </Layout>
);

const CtaIcon = ({ imageSrc, imageAlt }) => (
  <CtaIconLayout>
    <img src={imageSrc} alt={imageAlt} />
  </CtaIconLayout>
);

const CtaLabel = styled.div`
  margin: auto 8px;
`;

const CtaIconLayout = styled.div`
  width: 24px;
  min-width: 16px;
  height: 24px;
  min-height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  & > img {
    max-width: 100%;
    max-height: 100%;
  }
`;

const Layout = styled.div`
  width: ${({ width }) => (width ? `${width}px` : "100%")};
  padding: 20px 0px;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  @media (max-width: 375px) {
    width: 90%;
  }
`;

const Row = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  flex-direction: row;
`;

const SmallCtaContainer = styled.div`
  flex: 1;
  padding: 5px;
`;

const Cta = styled(PrimaryButton)`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background-color: #448eff;
  opacity: ${({ isLoading }) => (isLoading ? 0.6 : 1)};
`;

const enhancer = compose(
  withState("openWatermarkModal", "handleOnCloseWatermarkModal", false),
  withHandlers({
    onClickShowPurchaseWatermark: ({ handleOnCloseWatermarkModal }) => () => {
      handleOnCloseWatermarkModal(true);
    },
    onCloseModal: ({ handleOnCloseWatermarkModal }) => () => {
      handleOnCloseWatermarkModal(false);
      if (window.gtag) {
        window.gtag("event", "close_watermark_modal");
      }
    },
  })
);

export default enhancer(StoryActions);
